import { selectWarehouse } from 'containers/Warehouses/warehousesSlice'
import useNavigateWithScrollSave from 'hooks/useNavigateWithScrollSave'
import useWarehousesLoading from 'hooks/useWarehousesLoading'
import React, { useContext, useEffect, useState, useRef } from 'react'
import { ViewContext } from 'context/ViewContext'
import { useHistory, useParams } from 'react-router-dom'
import MagResignation from './resignation/Termination'
import useTranslation from 'hooks/useTranslation'
import RentalExtension from './RentalExtension'
import MagAccessories from './MagAccessories'
import MagNumber from 'components/MagNumber'
import MagCancel from './resignation/Cancel'
import Invoices from '../Account/Invoices'
import { useReduxSelector } from 'store'
import MagDetails from './MagDetails'
import MagHistory from './MagHistory'
import MagAccess from './MagAccess'
import { SECTION_TYPES } from '.'

const appType = process.env.REACT_APP_TYPE

const SubMenu: React.FC = () => {
  const mobile = useContext(ViewContext)
  const [goodbye, setGoodbye] = useState(0)
  const { type, id } = useParams<warehouse.PageParams>()
  const { number, contractId, isShared, acronym, rentableType, needPayment } = useReduxSelector(state => selectWarehouse(state, id))
  useWarehousesLoading(!contractId)

  const listRef = useRef<HTMLDivElement>(null)
  const menuRef = useRef<HTMLDivElement>(null)

  const { goBack, replace } = useHistory()
  const { t } = useTranslation('warehouse')
  const navigate = useNavigateWithScrollSave(true, listRef)

  useEffect(() => {
    if (mobile) {
      document.body.style.setProperty('overflow', 'hidden')
      return () => {
        document.body.style.removeProperty('overflow')
      }
    }
  }, [mobile])

  const onTouch = (e: React.TouchEvent<HTMLElement>) => {
    const list = listRef.current
    const menu = menuRef.current
    if (!list || !menu) return

    let updateState = true
    const { scrollTop } = list
    const initialY = e.touches[0].clientY

    const touchMove = (e: TouchEvent) => {
      const currentY = e.touches[0].clientY
      const difference = currentY - initialY
      updateState = difference < 80
      if (updateState) setGoodbye(difference > 0 ? Number((difference / 50).toFixed(1)) : 0)
    }

    const touchEnd = () => {
      setGoodbye(0)
      if (!updateState) back()
      menu.removeEventListener('touchend', touchEnd, false)
      menu.removeEventListener('touchmove', touchMove, false)
    }

    if (scrollTop < 1) {
      menu.addEventListener('touchend', touchEnd, false)
      menu.addEventListener('touchmove', touchMove, false)
    }
  }

  const back = () => window.history ? goBack() : replace('/warehouse')

  return (
    <div
      className='warehouse'
      style={{ overflow: 'hidden' }}>

      <div className='warehouse__main'>
        <MagNumber
          number={number}
          acronym={acronym}
          isShared={isShared}
          rentableType={rentableType}
        />
      </div>

      <div
        ref={menuRef}
        style={{ top: ((isShared ? 15 : 0) + ((appType === 'mm' && rentableType === 'parking') ? 15 : 0))  }}
        className='menu__main'
        onTouchStart={onTouch}>

        <div className='menu__status --noShadow'>
          <div className='line' />
          {(type === SECTION_TYPES.invoices || type === SECTION_TYPES.accessories || type === SECTION_TYPES.details || type === SECTION_TYPES.access || type === SECTION_TYPES.history) && <div className='status__options'>
            <h4>{t(getTitle(type))}</h4>
          </div>}
        </div>

        <div className='menu__full'>
          {goodbye !== 0 && <div
            className='menu__goodbye'
            style={{
              transform: `scale(${goodbye})`,
              marginTop: `${goodbye - 1}em`,
              padding: `${goodbye}em`
            }}>
            {t('back')}
          </div>}

          {(() => {
            switch (type) {
              case SECTION_TYPES.invoices: return (
                <div
                  ref={listRef}
                  className='account menu__section'>
                  <Invoices onlyBody needPayment={needPayment} />
                </div>
              )

              case SECTION_TYPES.history: return (
                <MagHistory
                  full
                  id={id}
                  ref={listRef}
                />
              )

              case SECTION_TYPES.details: return (
                <MagDetails
                  ref={listRef}
                  navigate={navigate}
                />
              )

              case SECTION_TYPES.accessories: return (
                <MagAccessories
                  ref={listRef}
                />
              )

              case SECTION_TYPES.termination: return (
                <MagResignation />
              )

              case SECTION_TYPES.extension: return (
                <RentalExtension />
              )

              case SECTION_TYPES.cancel: return (
                <MagCancel />
              )

              default: return (
                <MagAccess
                  full
                  ref={listRef}
                />
              )
            }
          })()}
        </div>
      </div>
    </div>
  )
}

const getTitle = (type: string) => {
  switch (type) {
    case SECTION_TYPES.invoices: return 'invoices'
    case SECTION_TYPES.access: return 'manageAccess'
    case SECTION_TYPES.history: return 'listOfEvents'
    case SECTION_TYPES.accessories: return 'magBoxAccessories'
    default: return 'rentalDetails'
  }
}

export default SubMenu